import axios from 'axios'

export async function fetchArSummary() {
  const res = await axios.get('finance/ar/summary')
  return res.data
}

export async function fetchArDocuments(params = {}) {
  const res = await axios.get('finance/ar/documents', { params })
  return res.data
}

export async function getArDocument(id) {
  const res = await axios.get(`finance/ar/documents/${id}`)
  return res.data
}

export async function syncArFromDte() {
  const res = await axios.post('finance/ar/sync-from-dte')
  return res.data
}

export async function createArPayment(data) {
  const res = await axios.post('finance/ar/payments', data)
  return res.data
}

export async function markArUncollectible(id) {
  const res = await axios.post(`finance/ar/documents/${id}/uncollectible`)
  return res.data
}

export async function fetchCollectionActions(params = {}) {
  const res = await axios.get('finance/ar/collection-actions', { params })
  return res.data
}

export async function createCollectionAction(data) {
  const res = await axios.post('finance/ar/collection-actions', data)
  return res.data
}

export async function fetchApSummary() {
  const res = await axios.get('finance/ap/summary')
  return res.data
}

export async function fetchApDocuments(params = {}) {
  const res = await axios.get('finance/ap/documents', { params })
  return res.data
}

export async function getApDocument(id) {
  const res = await axios.get(`finance/ap/documents/${id}`)
  return res.data
}

export async function syncApFromPurchases() {
  const res = await axios.post('finance/ap/sync-from-purchases')
  return res.data
}

export async function createApPayment(data) {
  const res = await axios.post('finance/ap/payments', data)
  return res.data
}

export async function cancelApDocument(id) {
  const res = await axios.post(`finance/ap/documents/${id}/cancel`)
  return res.data
}

export async function fetchTreasurySummary() {
  const res = await axios.get('finance/treasury/summary')
  return res.data
}

export async function fetchTreasuryAccounts(params = {}) {
  const res = await axios.get('finance/treasury/accounts', { params })
  return res.data
}

export async function createTreasuryAccount(data) {
  const res = await axios.post('finance/treasury/accounts', data)
  return res.data
}

export async function updateTreasuryAccount(id, data) {
  const res = await axios.patch(`finance/treasury/accounts/${id}`, data)
  return res.data
}

export async function fetchTreasuryMovements(params = {}) {
  const res = await axios.get('finance/treasury/movements', { params })
  return res.data
}

export async function createTreasuryMovement(data) {
  const res = await axios.post('finance/treasury/movements', data)
  return res.data
}

export async function createTreasuryTransfer(data) {
  const res = await axios.post('finance/treasury/transfers', data)
  return res.data
}

export async function fetchReconSummary(params = {}) {
  const res = await axios.get('finance/reconciliation/summary', { params })
  return res.data
}

export async function fetchReconImports(params = {}) {
  const res = await axios.get('finance/reconciliation/imports', { params })
  return res.data
}

export async function createReconImport(data) {
  const res = await axios.post('finance/reconciliation/imports', data)
  return res.data
}

export async function getReconImport(id) {
  const res = await axios.get(`finance/reconciliation/imports/${id}`)
  return res.data
}

export async function closeReconImport(id) {
  const res = await axios.post(`finance/reconciliation/imports/${id}/close`)
  return res.data
}

export async function fetchReconLines(params = {}) {
  const res = await axios.get('finance/reconciliation/lines', { params })
  return res.data
}

export async function fetchReconSuggestions(params = {}) {
  const res = await axios.get('finance/reconciliation/suggestions', { params })
  return res.data
}

export async function autoMatchRecon(data = {}) {
  const res = await axios.post('finance/reconciliation/auto-match', data)
  return res.data
}

export async function matchReconLine(lineId, movementId) {
  const res = await axios.post(`finance/reconciliation/lines/${lineId}/match`, {
    movement_id: movementId,
  })
  return res.data
}

export async function unmatchReconLine(lineId) {
  const res = await axios.post(`finance/reconciliation/lines/${lineId}/unmatch`)
  return res.data
}

export async function ignoreReconLine(lineId) {
  const res = await axios.post(`finance/reconciliation/lines/${lineId}/ignore`)
  return res.data
}

export async function createMovementFromReconLine(lineId, data = {}) {
  const res = await axios.post(`finance/reconciliation/lines/${lineId}/create-movement`, data)
  return res.data
}

export async function fetchCashflowSummary(params = {}) {
  const res = await axios.get('finance/cashflow/summary', { params })
  return res.data
}

export async function fetchCashflowTimeline(params = {}) {
  const res = await axios.get('finance/cashflow/timeline', { params })
  return res.data
}

export async function fetchCashflowDueDetail(params = {}) {
  const res = await axios.get('finance/cashflow/due-detail', { params })
  return res.data
}

export async function fetchFinanceDashboard(params = {}) {
  const res = await axios.get('finance/dashboard', { params })
  return res.data
}

export async function fetchCostCenters(params = {}) {
  const res = await axios.get('finance/cost-centers', { params })
  return res.data
}

export async function createCostCenter(data) {
  const res = await axios.post('finance/cost-centers', data)
  return res.data
}

export async function updateCostCenter(id, data) {
  const res = await axios.patch(`finance/cost-centers/${id}`, data)
  return res.data
}

export async function deactivateCostCenter(id) {
  const res = await axios.post(`finance/cost-centers/${id}/deactivate`)
  return res.data
}

export async function fetchCostCenterAnalysis() {
  const res = await axios.get('finance/cost-centers/analysis')
  return res.data
}

export async function assignApCostCenter(id, costCenterId) {
  const res = await axios.post(`finance/ap/documents/${id}/assign-cost-center`, {
    cost_center_id: costCenterId || null,
  })
  return res.data
}

export async function assignArCostCenter(id, costCenterId) {
  const res = await axios.post(`finance/ar/documents/${id}/assign-cost-center`, {
    cost_center_id: costCenterId || null,
  })
  return res.data
}

export async function fetchFinanceCategories() {
  const res = await axios.get('finance/categories')
  return res.data
}

export async function fetchBudgetLines(params = {}) {
  const res = await axios.get('finance/budgets/lines', { params })
  return res.data
}

export async function upsertBudgetLine(data) {
  const res = await axios.post('finance/budgets/lines', data)
  return res.data
}

export async function deleteBudgetLine(id) {
  const res = await axios.delete(`finance/budgets/lines/${id}`)
  return res.data
}

export async function fetchBudgetCompare(params = {}) {
  const res = await axios.get('finance/budgets/compare', { params })
  return res.data
}

export async function fetchOtProfitability(params = {}) {
  const res = await axios.get('finance/profitability/ot', { params })
  return res.data
}

